import DateSelector from '@visa/vds/date-selector';
import Input from '@visa/vds/input';
import Row from '@visa/vds/row';
import isValid from 'date-fns/isValid';
import React, { useEffect, useState } from 'react';
import { DateHelper } from '_helpers/DateHelper';
import '../../Style/Store.css';
import { Label } from 'reactstrap';
import MCSOverlayLoading from 'components/MCSOverlayLoading';
import { trackPromise, usePromiseTracker } from 'react-promise-tracker';

const VSTSDateSelectorComponent = (props) => {

    const [minDate, setMinDate] = useState(null);
    const [selectedDate, setSelectedDate] = useState(null);
    const { promiseInProgress } = usePromiseTracker();

    const GetMinDate = async () => {
        await trackPromise(new Promise((resolve) => {
            if (props.currentVstsSubscriptionEndDate) {
                let date = new Date(props.currentVstsSubscriptionEndDate)
                setMinDate(date);
                var canSelectDate = new Date(date);
                canSelectDate.setDate(canSelectDate.getDate() + 1);
                setSelectedDate(canSelectDate)
                props.setSelectedVSTSStartDate(DateHelper.ToUTCDateTime(canSelectDate))
                props.setSelectedVSTSEndDate(DateHelper.IncrementDate(canSelectDate, props.duration, false, "dd MMM yyyy", true))
            } else {
                const today = new Date()
                today.setHours(0, 0, 0, 0)

                setMinDate(today);
                setSelectedDate(today)
                props.setSelectedVSTSStartDate(DateHelper.ToUTCDateTime(today))
                props.setSelectedVSTSEndDate(DateHelper.IncrementDate(today, props.duration, false, "dd MMM yyyy", true))
            }
            resolve();
        }));
    }

    useEffect(() => {
        GetMinDate()
    }, [props.currentVstsSubscriptionEndDate])

    const onSelectDate = (date) => {
        if (date != null) {
            props.setSelectedVSTSStartDate(DateHelper.ToUTCDateTime(date));
            props.setSelectedVSTSEndDate(DateHelper.IncrementDate(date, props.duration, false, "dd MMM yyyy", true));
            props.setShowVSTSStartDateError(false);
        }
        console.log(date)
    }

    return (
        <>
            {promiseInProgress && <MCSOverlayLoading />}
            {!promiseInProgress &&
                <>
                    <Row>
                        <DateSelector
                            id="VSTS-start-date-input"
                            popperProps={{ placement: 'auto' }}
                            ariaLabelCalendarButtonIcon={(date) => (
                                isValid(new Date(date))
                                    ? `Choose Start Date, selected Start date is ${date}`
                                    : 'Choose Start Date'
                            )}
                            name="date-picker-selected"
                            invalid={props.showVSTSStartDateError}
                            showErrorText
                            minDate={minDate}
                            selected={selectedDate}
                            errorText={props.errorText}
                            onSelect={date => onSelectDate(date)}
                            helpText="Click calendar icon to select date"
                            showHelpText
                            formatInputValue='dd MMM yyyy'
                            className="subscription-select-startdate"
                            label={`Start Date`}
                        />
                    </Row>
                    {props.currentVstsSubscriptionEndDate &&
                        <>
                            <Row>
                                <Label style={{ fontSize: "11px", lineHeight: "1.2" }}>{`Please choose a start date after current active subscription end date of ${DateHelper.ToFormattedDate(props.currentVstsSubscriptionEndDate)}.`}</Label>
                            </Row>
                        </>
                    }
                    <Row>
                        <Input id="VSTS-end-date-input" className="subscription-select-startdate" label="End Date" name="end-date" value={(props.selectedVSTSEndDate) ? DateHelper.ToFormattedDate(props.selectedVSTSEndDate) : ''} readOnly />
                    </Row>
                </>
            }
        </>
    )
}

export default VSTSDateSelectorComponent